// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconStepperMinus: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="1" viewBox="0 0 11 1">
            <path
                fill="currentColor"
                d="M0,0.5 C0,0.229166667 0.270089286,0 0.589285714,0 L10.4107143,0 C10.7299107,0 11,0.229166667 11,0.5 C11,0.770833333 10.7299107,1 10.4107143,1 L0.589285714,1 C0.270089286,1 0,0.770833333 0,0.5 Z"
            />
        </svg>
    );
};

export default React.memo(IconStepperMinus);
